import React, { createContext, useContext } from 'react';
import { useTheme } from 'next-themes';
import { Toaster, type ToasterProps } from 'sonner';

export interface TemplateContextValue {
  // Extend later as needed
}

const TemplateContext = createContext<TemplateContextValue | null>(null);

export const useTemplateContext = (): TemplateContextValue => {
  const ctx = useContext(TemplateContext);
  if (!ctx) {
    throw new Error('useTemplateContext must be used within TemplateProvider');
  }
  return ctx;
};

interface TemplateProviderProps {
  children: React.ReactNode;
}

export const TemplateProvider: React.FC<TemplateProviderProps> = ({ children }) => {
  const value: TemplateContextValue = {};
  const { theme = 'system' } = useTheme();
  return (
    <TemplateContext.Provider value={value}>
      {children}
      <Toaster
        theme={theme as NonNullable<ToasterProps['theme']>}
        className='toaster group'
        richColors
        closeButton
        position='top-right'
        style={
          {
            '--normal-bg': 'var(--popover)',
            '--normal-text': 'var(--popover-foreground)',
            '--normal-border': 'var(--border)',
          } as React.CSSProperties
        }
      />
    </TemplateContext.Provider>
  );
};

export default TemplateProvider;
